import { createFileRoute, redirect } from '@tanstack/react-router'

import { isGateVisitorAuthenticated } from '@/access/gate-session'
import { getPortalGate, PORTAL_GATE_PATH } from '@/access/portal-access'
import { isAdmin } from '@/hooks/use-is-admin'
import { AcceptTermsPage } from '@/pages/accept-terms/accept-terms-page'
import { store } from '@/store'

export const Route = createFileRoute('/accept-terms')({
  beforeLoad: async () => {
    if (!(await isGateVisitorAuthenticated())) {
      throw redirect({ to: '/login', replace: true })
    }

    // This route lives at the root, outside the _private/_auth layouts, so this
    // guard is the ONLY enforcement on /accept-terms. Recompute the same gate the
    // layout guards use (single source of truth) so the screen can never disagree
    // with them: admins must never see the partner T&C wizard, an already-allowed
    // partner must not be stranded here, and a beta-locked partner belongs on the
    // beta-locked screen — not being offered terms for a portal they can't enter.
    if (isAdmin()) {
      throw redirect({ to: '/admin/partners', replace: true })
    }
    const gate = getPortalGate(store.getState().partner)
    if (gate.kind === 'allow') {
      throw redirect({ to: '/dashboard', replace: true })
    }
    if (gate.kind !== 'terms') {
      throw redirect({ to: PORTAL_GATE_PATH(gate), replace: true })
    }
  },
  component: AcceptTermsPage,
})
